(function () {
    'use strict';

    angular
        .module('app')
        .controller('UsersController', UsersController);

    UsersController.$inject = ['$state',];

    function UsersController($state) {
        // var vm = this;


        activate();

        function activate() {
            // Run on load
            if ($state && $state.current && $state.current.name === 'users') {
                $state.go('users.list');
            }
        }
    }
})();